import { CloudUploadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useMemo } from "react";
import { openReportVocSeriesUpload } from "./reportVocSeriesUploadOpener";
import { profileStore } from "src/stores/profile-store";
import { useShallow } from "zustand/react/shallow";
import { RolesNameEnum } from "src/entity/common/roles.enum";

const UploadReportVocSeries = () => {
  const profile = profileStore(useShallow((state) => state.profile));

  const canUpload = useMemo(() => {
    if (profile?.roles.includes(RolesNameEnum.COMPANY_ADMIN) || profile?.roles.includes(RolesNameEnum.SYSTEM_ADMIN)) {
      return true;
    }
    return false;
  }, [profile?.roles]);

  if (!canUpload) return null;

  return (
    <Button
      type="text"
      icon={<CloudUploadOutlined style={{ fontSize: "28px", color: "#9D9C9B" }} />}
      onClick={() => openReportVocSeriesUpload()}
    />
  );
};

export default UploadReportVocSeries;
